export const GOOGLE_MAP_URL = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyApllL0daMteaxc2gF1JW3d8R5Q-L1dE5U&libraries=places&language=fr&region=FR' ;


// WEBPACK FOOTER //
// ./src/constants/defaults.js